export enum QUERY_NAME {
  fetchPublicPage = 'fetchPublicPage',
  fetchPublicPageFiles = 'fetchPublicPageFiles',
}
